const defaultUserData = {
  balance: 1000,
  tokens: 10,
  logs: [],
  nickname: "",
  email: "",
};
export default defaultUserData;
